import _ from 'lodash';
import { COMMISSION_SETTLEMENT_STATUS, TAG_TYPE } from '@/constants';
import { Message, MessageBox } from 'element-ui';
import { autoLoading, request } from 'beans-admin-plugin';

export const OrderCommissionColumns = [
  {
    prop: 'order_so_id',
    label: '订单号',
    renderCell(h, { row }) {
      return <c-link-button to={{ name: 'orders.show', params: { id: row.order_id } }}>{row.order_so_id}</c-link-button>
    }
  },
  {
    prop: 'invitee_nickname',
    label: '消费者',
    renderCell(h, { row }) {
      return <c-link-button to={{ name: 'users.show', params: { id: row.invitee_id } }}>{row.invitee_nickname} - {row.invitee_no}</c-link-button>
    }
  },
  {
    prop: 'amount',
    label: '佣金',
  },
];

export default ({ handleTransferSuccess = _.noop, handleRejectSuccess = _.noop } = {}) => [
  {
    prop: 'id',
    label: '编号',
    width: 80,
    action: ['hide-in-detail']
  },
  {
    prop: 'serial_no',
    label: '单号',
  },
  {
    prop: 'user',
    label: '用户',
    renderCell(h, { row }) {
      const { id, nickname, no } = _.get(row, 'user', {});
      return <c-link-button to={{ name: 'users.show', params: { id } }}>{nickname} - {no}</c-link-button>
    }
  },
  {
    prop: 'amount',
    label: '结算金额',
  },
  {
    prop: 'status',
    label: '状态',
    renderCell(h, { row }) {
      return <el-tag type={TAG_TYPE[row.status]}>{COMMISSION_SETTLEMENT_STATUS[row.status]}</el-tag>
    }
  },
  {
    prop: 'order_commissions',
    label: '结算明细',
    width: 60,
    type: 'expand',
    action: ['hide-in-table'],
    renderCell(h, { row }) {
      return <c-source-table style={{ width: '660px' }} table={{ data: row.order_commissions }} columns={OrderCommissionColumns} />
    }
  },
  {
    prop: 'created_at',
    label: '创建时间',
    renderCell: 'time',
    sort: 'order_by'
  },
  {
    prop: 'action',
    label: '操作',
    fixed: 'right',
    detail: true,
    action: ['hide-in-detail'],
    renderCell(h, scope) {
      const { row: { status, id } } = scope;
      const handleTransfer = async() => {
        await MessageBox.confirm('同意提现申请并打款？', '同意');
        await autoLoading(
          request.put(`/commission_settlement_applications/${id}/transfer`)
        );
        Message.success('操作成功');
        handleTransferSuccess();
      }

      const handleReject = async() => {
        await MessageBox.confirm('拒绝提现申请并打款？', '拒绝');
        await autoLoading(
          request.put(`/commission_settlement_applications/${id}/reject`)
        );
        Message.success('操作成功');
        handleRejectSuccess();
      }

      return (
        status === 'pending' && (
          <div style="display: flex">
            <el-button type="text" onClick={handleTransfer}>同意申请并打款</el-button>
            <el-button type="text" onClick={handleReject}>拒绝</el-button>
          </div>
        )
      )
    }
  }
];
